export default "__VITE_ASSET__d61a79ec__"